<template>
  <el-dialog
    title="专业阅片设置"
    :visible.sync="dialogVisible"
    :modal-append-to-body="false"
    :before-close="close"
    width="526px"
  >
    <el-form ref="form" label-width="150px" size="small">
      <el-form-item label="端口号">
        <el-input
          v-model="form.port"
          placeholder="默认:8484"
          style="width: 150px"
        ></el-input>
        <el-button type="default" @click="testPort">测试</el-button>
      </el-form-item>
      <el-form-item></el-form-item>
      <el-form-item label="启用专业阅片">
          <el-checkbox v-model="form.checked"/>
      </el-form-item>
      <el-form-item label="软件下载">
         <el-button type="default" :disabled="!isWin">
            <a :href="dcmviwerurl" download="专业阅片工具">下载</a>
         </el-button>
      </el-form-item>
       <el-form-item label="" v-if="!isWin">
         <div style="color:#ff5656;font-size:12px">仅提供window系统版本专业阅片软件下载</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setPort">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import axios from "axios";
import { mapGetters } from 'vuex';

export default {
  name: "about",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        port: "8484",
        checked: false
      },
      isWin: false,
    };
  },
   computed: {
    ...mapGetters([
      "dcmviwerurl"
    ]),
  },
  mounted() {
    this.isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");  
    this.form.port = localStorage.getItem("viewerPort")
      ? localStorage.getItem("viewerPort")
      : this.form.port;

     this.form.checked = localStorage.getItem("viewerCheck")=='true'
      ? true
      : this.form.checked;
      
  },
  methods: {
    close() {
      this.$emit("closeDialog", false);
    },
    setPort() {
       localStorage.setItem("viewerPort", this.form.port);
       localStorage.setItem("viewerCheck", this.form.checked);
       this.$message({
        type: 'success',
        message: "专业阅片设置成功"
      });
      this.close();
    },
    testPort() {
      axios
        .post("http://127.0.0.1:" + this.form.port + "/check")
        .then((res) => {
          if (res.data.code == 1) {
            localStorage.setItem("viewerState", true);
            this.$message({
              type: 'success',
              message: "测试链接成功"
            });
          }
        })
        .catch((error) => {
          console.log(error);
          localStorage.setItem("viewerState", false);
          this.$message({
              type: 'error',
              message: "测试链接失败"
            });
        });
    },
  },
};
</script>
